export default "__VITE_ASSET__DsoXyQyy__"